export default {"src":"/_next/static/media/gl-carousel-1-6.6063fc13.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};